module.exports = __webpack_public_path__ + "images/boss-6f70e6be9314e6a78edc9ae162e6b60a.png";